import { LegacySearchResults, TypesenseSearchResults } from './components';
import { SearchResultPanelProps } from './types';
import { isTest } from '@/legacy/utils/env';

export const SearchResultPanel = ({
  isPauseSearch,
  searchValue,
  onItemSelect,
  searchContainerResults,
}: SearchResultPanelProps) => {
  if (!searchValue) {
    return null;
  }

  if (isPauseSearch) {
    // Typesense search in old UI has better UX without a dedicated loading UI state
    return null;
  }

  return !isTest ? (
    <TypesenseSearchResults
      searchValue={searchValue}
      onItemSelect={onItemSelect}
      searchContainerResults={searchContainerResults}
    />
  ) : (
    <LegacySearchResults
      searchValue={searchValue}
      onItemSelect={onItemSelect}
      searchContainerResults={searchContainerResults}
    />
  );
};
